<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="原批次"
                         width="100"></el-table-column>

        <el-table-column prop="display_name"
                         label="上传文件">
          <template slot-scope="scope">
            <span style="cursor:pointer;color:rgb(88,157,248)"
                  @click="onDownSourceFile(scope.row.id)">{{scope.row.display_name}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="withdraw_type"
                         label="类别"
                         width="200">
          <template slot-scope="scope">
          <span v-for="(item, index) in financeOptions.withdraw_type"
              :key="index"
              v-if="scope.row.withdraw_type === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="admin_name"
                         label="发起者"
                         width="70"></el-table-column>
        <el-table-column prop="created_at"
                         label="上传时间"
                         width="160"></el-table-column>
        <el-table-column prop="success_count"
                         label="任务进度">
          <template slot-scope="scope">
            <sj-progress
              :percentages="taskBatchPercentage(scope.row)"
              :status="taskBatchStatus(scope.row)"
              :show-text="true"
              :stroke-width="10"></sj-progress>
            <span>成功: </span>
            <span>{{scope.row.success_count}}</span>
            <span>失败: </span>
            <span>{{scope.row.error_count}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="status"
                         label="状态"
                         width="80">
          <template slot-scope="scope">
            <span v-for="item in status"
                  v-if="item.value === scope.row.status">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <el-button type="text"
                       size="mini"
                       @click="onDownErrorFile(scope.row.id)"
                       v-if="scope.row.error_count > 0">
              下载错误行
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>


<script>
import table from '@core/mixins/table'
import downloadJS from 'downloadjs'
import SjProgress from '@/components/sj-progress'
import taskBatchMixins from '@/views/task-batch/task-batch.mixins'


export default {
  mixins: [table, taskBatchMixins],
  components: {SjProgress},
  data () {
    return {
      table: [],
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
    }
  },
  created () {
  },
  computed: Vuex.mapState({
    financeOptions: state => state.finance.options,
    status: state => state.taskBatch.status,
  }),
  methods: {
    ...Vuex.mapActions({}),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('batchRollbackTable', params)
    },

    onDownSourceFile (id) {
      this.$confirm('确认下载文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        downloadJS(request.items.downSourceFile(id))
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '下载已取消',
        })
      })
    },

    onDownErrorFile (id) {
      this.$confirm('确认下载错误行?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        downloadJS(request.items.downErrorFile(id))
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '下载已取消',
        })
      })
    },
  },
}
</script>


<style lang="scss"
       scoped>
.withdraw-option {
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 0 20px;

  .arc-upload {
    flex-shrink: 0;
    flex-grow: 0;
    margin: 5px 10px 5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/finance/pages/BatchWithdrawOptionTable.vue